import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import agentsReducer from './slices/agentsSlice';
import providersReducer from './slices/providersSlice';
import callsReducer from './slices/callsSlice';
import integrationsReducer from './slices/integrationsSlice';
import socketReducer from './slices/socketSlice';
import subscriptionReducer from './slices/subscriptionSlice';
import modelOptionsReducer from './slices/modelOptionsSlice';
import permissionsReducer from './slices/permissionsSlice';
import featureTogglesReducer from './slices/featureTogglesSlice';
import adminReducer from './slices/adminSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    agents: agentsReducer,
    providers: providersReducer,
    calls: callsReducer,
    integrations: integrationsReducer,
    socket: socketReducer,
    subscription: subscriptionReducer,
    modelOptions: modelOptionsReducer,
    permissions: permissionsReducer,
    featureToggles: featureTogglesReducer,
    admin: adminReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for serializable check
        ignoredActions: ['calls/setSocket', 'socket/initializeSocket', 'socket/disconnectSocket'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.socket'],
        // Ignore these paths in the state
        ignoredPaths: ['calls.socket', 'socket.socket'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

// Export types for TypeScript (if needed)
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
